import CoreHero from './CoreHero';

export { type CoreHeroProps } from './CoreHero';
export default CoreHero;
